module.exports = __webpack_public_path__ + "static/media/tablet_free.bee39a85.png";